export default __webpack_public_path__ + "static/poster-c6569c8c54b506c39ede96009859fe8e.jpg";